export default "__VITE_ASSET__35552fbd__"